import React, { useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { HelpCenterService } from '../../../../services/helpcenter-service';
import { messages } from '../messages';
import { submitZendeskSsoForm } from '../../../../services/zendesk-sso-service';

export const useSupportCasesItem = () => {
  const handleSupportCasesClicked = useCallback(async (e: React.MouseEvent) => {
    e.stopPropagation();
    await submitZendeskSsoForm(HelpCenterService.getSupportCasesUrl());
  }, []);

  return useMemo(
    () => ({
      description: <FormattedMessage {...messages.supportCases} />,
      testId: 'support-center-support-cases-item',
      onClick: handleSupportCasesClicked,
    }),
    [handleSupportCasesClicked],
  );
};
